import {
  EmailRounded,
  FacebookRounded,
  Language,
  LinkedIn,
  PhoneRounded,
  Telegram,
} from "@mui/icons-material";
import { Box, Card, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const AuthContainer = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundImage: "url(/login-image.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />

      <Card
        sx={{
          zIndex: 1,
          borderRadius: "16px",
          boxShadow: 3,
          maxWidth: "80%",
          position: "relative",
        }}
      >
        {children}
      </Card>
      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
        }}
      >
        <Typography variant="body2" color="white">
          Orbit Technology Solution.
        </Typography>
        <Box sx={{ mt: 1, display: "flex", justifyContent: "center", gap: 2 }}>
          <Box
            sx={{
              color: "whitesmoke",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <PhoneRounded sx={{ cursor: "pointer", color: "whitesmoke" }} />
            +251963626061
          </Box>
          <Box
            sx={{
              color: "whitesmoke",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <EmailRounded sx={{ cursor: "pointer", color: "whitesmoke" }} />
            ceo@orbit.et
          </Box>
          <Box
            sx={{
              color: "whitesmoke",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Link to="https://www.orbit.et" target="_blank">
              <Language sx={{ cursor: "pointer", color: "whitesmoke" }} />
            </Link>
            <Link
              to="https://www.orbit.et"
              target="_blank"
              style={{
                color: "whitesmoke",
                "&:hover": { color: "whitesmoke" },
                "&:focus": { color: "whitesmoke" },
              }}
            >
              www.orbit.et
            </Link>
          </Box>
          <Link
            to="https://web.facebook.com/p/Orbit-Technology-Solution-PLC-100086330515097?_rdc=1&_rdr"
            target="_blank"
          >
            <FacebookRounded sx={{ cursor: "pointer", color: "#3b5998" }} />
          </Link>
          <Link to="https://www.t.me/orbitet" target="_blank">
            <Telegram sx={{ cursor: "pointer", color: "#0398e1" }} />
          </Link>
          <Link to="https://www.linkedin.com/company/orbitet/" target="_blank">
            <LinkedIn sx={{ cursor: "pointer", color: "#1972b7" }} />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthContainer;
